import MapperBase from './MapperBase.js';

class RankingStatParametersMapper extends MapperBase {
    mapSingle(item) {
        if (!item || !item.parameter) {
            return item;
        }

        return {
            [item.parameter]: item
        };
    }

    mapArray(array) {
        let out = {};

        for (let i = 0; i < array.length; i++) {
            try {
                out = Object.assign(out, this.map(array[i]));
            } catch (error) {
                this.handleMappingError(error, out, array[i], i);
            }
        }

        return out;
    }

    mapObject(object) {
        let out = {};

        for (const key in object) {
            
            if (object.hasOwnProperty(key)) {
                try {
                    out[key] = Object.assign(out, this.map(object[key]));
                } catch (error) {
                    this.handleMappingError(error, out, object[key], key);
                }
            }
        }

        return out;
    }
}

export default RankingStatParametersMapper;